import { createSelector } from 'reselect'
import libraryObjectTypes from 'helpers/enums/entityTypes'
import getLessonSelector from 'redux/selectors/lessons/lesson_selector'

export default createSelector(
	[getLessonSelector],
	getLesson => lessonUid => {
		const lesson = getLesson(lessonUid)
		const title = lesson.library_object_type === libraryObjectTypes.LESSON
			? lesson.data.name
			: ''
		return title
	}
)
